export const getOnboardingInsightsUrl = () => 'agency/onboarding_insights';
